import { useMemo } from 'react';
import {
    createCallAngularMethodEffect,
    createChangeHandler,
    createLoadHtmlEffect,
    logPlanChangeAnalyticsEvent,
    redirect,
    updateHiddenPlanInput
} from './effects';

/**
 * @param {UsePlanPickerSideEffectProps} props
 */
export default function usePlanPickerSideEffects({ action }) {
    return useMemo(() => {
        const effects = [logPlanChangeAnalyticsEvent, updateHiddenPlanInput];

        if (action.kind === 'redirect') {
            effects.push(redirect);
        } else if (action.kind === 'loadHtml') {
            effects.push(createLoadHtmlEffect(action.targetId, { fallback: redirect }));
        } else if (action.kind === 'callAngularMethod') {
            effects.push(
                createCallAngularMethodEffect(action.targetId, action.methodName, {
                    fallback: redirect
                })
            );
        }

        return createChangeHandler(effects);
    }, [action]);
}

/**
 * @typedef {object} UsePlanPickerSideEffectProps
 * @prop {PlanChangeAction} action
 */

/**
 * @typedef {RedirectAction | LoadHtmlAction | CallAngularMethodAction} PlanChangeAction
 */

/**
 * @typedef {object} RedirectAction
 * @prop {'redirect'} kind
 */

/**
 * @typedef {object} LoadHtmlAction
 * @prop {'loadHtml'} kind
 * @prop {string} targetId
 */

/**
 * @typedef {object} CallAngularMethodAction
 * @prop {'callAngularMethod'} kind
 * @prop {string} methodName
 * @prop {string} targetId
 */
